export default function pluralize(count, noun, suffix = "s") {
  // TODO Current function implementation does not take into account all the rules for forming plurals of nouns.
  // TODO Please, verify each case separately, since additional implementation may be needed.
  return `${noun}${count !== 1 ? suffix : ""}`;
}
